import { makeFetchSlice, fetchDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { fetchHomeActiveConfig } from 'features/home/api'
import { HOME_ACTIVE_CONFIG_ENERGY_REDUCER_NAME } from 'features/home/consts'

const homeActiveConfigEnergySlice = makeFetchSlice(
  HOME_ACTIVE_CONFIG_ENERGY_REDUCER_NAME
)
export const homeActiveConfigEnergyReducer = homeActiveConfigEnergySlice.reducer
export const homeActiveConfigEnergyActions = homeActiveConfigEnergySlice.actions

export const fetchHomeActiveConfigEnergyThunk = (homeId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchDataThunk({
        dispatch,
        actions: homeActiveConfigEnergyActions,
        asyncFunc: () =>
          fetchHomeActiveConfig(homeId, {
            type: 'energy',
            redirect: true,
          }),
      })
    } catch (error) {
      console.log('Error fetching home active energy config', error)
    }
  }
}
